// extracted by mini-css-extract-plugin
module.exports = {"eyebrowWrapper":"style_eyebrowWrapper__GXIzA"};